import React from "react";
import { useTranslation } from "react-i18next";

export default function EmptyStatistics() {
	const { t } = useTranslation();

	return (
		<div className="card--empty">
			<div className="card--empty__content">
				<i className="card--empty__icon u-icon u-icon u-icon--huge u-icon--empty u-icon--empty--search" />
				<div className="card--empty__message u-mar--bottom--reset">
					{t("EVENT.EMPTY_STATE.NO_STATS")}
				</div>
			</div>
		</div>
	);
}
